module.exports = __webpack_public_path__ + "img/12.42506fe9.png";